'use client';
import { Slider, SliderProps, SxProps, Theme, ThemeProvider, useTheme } from '@mui/material';
import React, { FC } from 'react';
import classes from './styles.module.scss';
import { removeCommas } from '@/utils';
import SliderLabel from '../SliderLabel';
import { useTranslation } from '@/hook';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});
const cacheLtr = createCache({
  key: 'muiltr',
  stylisPlugins: [prefixer],
});
const styles: { [key: string]: SxProps<Theme> } = {
  sliderBottom: {
    height: '8px',
    '& .MuiSlider-thumb': {
      bgcolor: '#fff',
      borderWidth: '20px',
      border: 1.5,
    },
    '& .MuiSlider-rail': {
      bgcolor: '#EAECF0',
      opacity: 1,
    },
    '& .MuiSlider-mark': {
      height: '6px',
      bgcolor: '#D0D5DD',
    },
    '& .MuiSlider-markActive': {
      height: '0px',
    },
    '& .MuiSlider-valueLabel': {
      bgcolor: '#FFFFFF',
      boxShadow: 6,
      padding: '8px 12px',
      borderRadius: '8px',
      ':before': {
        display: 'none',
      },
      // top: '60px',
    },
    '& .MuiSlider-valueLabelLabel': {
      color: '#000',
    },
  },
};

interface ISlider {
  sliderLabel?: boolean;
}

const SliderUnControlled: FC<SliderProps & ISlider> = ({ sliderLabel = false, ...props }) => {
  const { IS_RTL } = useTranslation();
  const theme = useTheme();
  return (
    <CacheProvider value={IS_RTL ? cacheRtl : cacheLtr}>
      <ThemeProvider theme={{ theme, direction: IS_RTL ? 'rtl' : 'ltr' }}>
        <div className={classes.input_container}>
          <Slider
            {...props}
            value={removeCommas((props.value || 0) as number)}
            onChange={props.onChange}
            min={props.min || 0}
            max={props.max || 1000}
            sx={styles.sliderBottom}
          />
          {sliderLabel && <SliderLabel min={props.min || 0} max={props.max || 0} />}
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default SliderUnControlled;
